DialogEditEstadoTareaCtrl.$inject = ['$log', '$scope', '$http'];
export default function DialogEditEstadoTareaCtrl($log, $scope, $http) {
    var ID_ESTADO_SOLUCIONADA = 18;
    var ID_ESTADO_NO_HAY_NADA = 45;

    var vm = this;
    vm.model = $scope.model;
    vm.dialogHandler = $scope.dialog;
    vm.cargando = {
        datos: true,
        submit: false
    };
    vm.formDeshabilitado = true;

    cargarEstados(vm.model.tipo);

    function cargarEstados(tipo) {
        vm.formDeshabilitado = true;
        vm.cargando.datos = true;
        var url = Sigo.var.path + '/api/v1/estados/' + tipo;
        var promesa = $http.get(url);
        promesa.then(function (data) {
            var estados = data.data[tipo];
            estados.some(function (elem, index) {
                if (elem.id == ID_ESTADO_SOLUCIONADA || elem.id == ID_ESTADO_NO_HAY_NADA) {
                    estados.splice(index, 1);
                    return true;
                }
            });
            vm.estados = estados;

            vm.formDeshabilitado = false;
            vm.cargando.datos = false;
        });
        return promesa;
    }

    vm.editarEstado = editarEstado;

    function editarEstado(estadoId, codigos, tipo) {
        vm.formDeshabilitado = true;
        vm.cargando.submit = true;

        var url = Sigo.var.path + '/obras/editar-estado-' + tipo + '-tareas';
        var data = {
            codigos_tareas: codigos
        };
        if (tipo == 'estudio')
            data['estado_estudio_id'] = estadoId;
        else if (tipo == 'reparacion')
            data['estado_reparacion_id'] = estadoId;
        else
            throw new Error('Tipo no válido');

        var promise = $http.post(url, data);
        promise.then(function (data) {
            var respuesta = data.data;
            vm.model.tareas_actualizadas = respuesta.tareas_actualizadas;
            Sigo.UI.Messages.procesarRespuestaMultiplesAcciones(respuesta);
            vm.dialogHandler.close(respuesta);
        });
    }

    vm.cancelar = function () {
        vm.dialogHandler.cancel();
    }
}